import React from 'react';

import { Tabs, Nav, NavItem, TabContent } from 'elements/Tabs/Tabs';
import TabsSection from 'elements/Tabs/TabsSection/TabsSection';
import FilterableTabs from 'elements/Tabs/FilterableTabs/FilterableTabs';

import GridBlock from 'foundations/Grids/GridBlock';
import Icon from 'foundations/Icons/Icon';

/* eslint-disable react/prop-types */
export const Standard = ({ withIcon, large, tabsNumber = 3, bgColor }) => {
  const iconSize = large ? '80' : '40';
  const tabs = [];

  for (let i = 0; i < tabsNumber; i++) {
    tabs.push(
      <NavItem eventKey={i} key={`tab-${i}`}>
        {withIcon && <Icon icon={'information'} type={iconSize} /> }
        <label>Label</label>
      </NavItem>
    );
  }

  return (
    <Tabs id="tabsContainer" defaultActiveKey={1}>
      <Nav bsStyle='tabs' large={large} background={bgColor} icons={withIcon}>
        { tabs }
      </Nav>
      <TabContent animation></TabContent>
    </Tabs>
  );
};



export const Counter = ({ size, bgColor }) => {
  const items = [
    {letter: 'A', year: 2013},
    {letter: 'A', year: 2014},
    {letter: 'B', year: 2015},
    {letter: 'B', year: 2016},
    {letter: 'C', year: 2017},
    {letter: 'C', year: 2018},
  ];

  return (
    <article>
      <FilterableTabs
        items={items}
        primaryKey={'letter'}
        secondaryKey={'year'}
        primaryLabel={'content type'}
        secondaryLabel={'sections'}
        size={size}
        background={bgColor}
      >
        {(results) => results.map((item, i) =>
          <span key={`item-${i}`}></span>
        )}
      </FilterableTabs>
    </article>
  );
};

export const Section = ({ icons, rows, horizontal }) => {
  const tabs = [];

  for (let i = 1; i <= rows; i++) {
    tabs.push(
      <TabsSection.Tab indexKey={i} key={`tab-${i}`}>
        { icons && <Icon icon={'information'} type={'20'} responsive/> }
        <label>Tab {i}</label>
      </TabsSection.Tab>
    );
  }

  return (
    <TabsSection>
      <GridBlock modifier={'LeftSection'}>
        <TabsSection.Tabs icons={icons} horizontal={horizontal}>
          { tabs }
        </TabsSection.Tabs>
      </GridBlock>
    </TabsSection>
  );
};
/* eslint-enable react/prop-types */



// WEBPACK FOOTER //
// ./src/containers/elements/Tabs/constants/tabsLayouts.js